import type { ReactElement } from 'react';

/** 첫 로드 중 자리를 잡아 둘 회색 칸 수 — 데스크톱 3열 두 줄. */
const SKELETON_KEYS = Array.from({ length: 6 }, (_, index) => `skeleton-${index}`);

/** 목록 첫 로드 자리 — 카드와 같은 격자에 회색 사진 칸·글 줄을 깐다. 안내 문구는 보조 기술에만 읽힌다. */
export const PortfolioGridSkeleton = (): ReactElement => (
  <div>
    <p role="status" className="sr-only">
      포트폴리오를 불러오는 중입니다.
    </p>
    <ul aria-hidden className="grid grid-cols-1 gap-x-6 gap-y-14 sm:grid-cols-2 lg:grid-cols-3">
      {SKELETON_KEYS.map((key) => (
        <li key={key} className="flex flex-col">
          <div className="aspect-[4/3] w-full bg-muted/70" />
          <div className="mt-5 h-3.5 w-24 bg-muted" />
          <div className="mt-3 h-6 w-2/3 bg-muted" />
        </li>
      ))}
    </ul>
  </div>
);
